// Update your existing quickBookingRoutes.tsx file
// frontend/src/router/routes/quickBookingRoutes.tsx

import { Route } from "react-router-dom";
import QuickBookingLayout from "@/components/Layout/QuickBookingLayout";
import QuickBookingPage from "@/pages/QuickBookingPage";
import BookingSuccessPage from "@/pages/BookingSuccessPage";

export const quickBookingRoutes = [
  // Main booking route - wrapped with QuickBookingLayout like original
  <Route
    key="quick-book"
    path="/book/:serviceCode"
    element={
      <QuickBookingLayout showProgress={true} currentStep={1} totalSteps={3}>
        <QuickBookingPage />
      </QuickBookingLayout>
    }
  />,
  
  // Legacy route for backward compatibility (if needed)
  <Route
    key="quick-book-legacy"
    path="/quick-book/:serviceCode"
    element={
      <QuickBookingLayout showProgress={true} currentStep={1} totalSteps={3}>
        <QuickBookingPage />
      </QuickBookingLayout>
    }
  />,
  
  // Success page route
  <Route
    key="booking-success"
    path="/booking/success/:bookingId"
    element={
      <QuickBookingLayout
        showProgress={true}
        currentStep={3}  // Final step
        totalSteps={3}
      >
        <BookingSuccessPage />
      </QuickBookingLayout>
    }
  />,
];